(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kmc-mobile-back-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.getElementById('kmc-mobile-back-to-top');
    if (!button || button.dataset.initialized) return;
    button.dataset.initialized = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let scheduled = false;
    const update = () => {
      scheduled = false;
      button.hidden = !mobile.matches || window.scrollY < 600;
      if (button.hidden) return;
      const stickyCart = document.getElementById('md-sticky-atc');
      const offset = stickyCart?.classList.contains('show') ? stickyCart.offsetHeight : 0;
      button.style.setProperty('--kmc-back-to-top-offset', `${offset}px`);
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    };
    button.addEventListener('click', () => {
      const target = document.querySelector('header a[href]');
      target?.focus({ preventScroll: true });
      window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
